/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M19 8L19 12M19 8V8C20.6569 8 22 6.65685 22 5V5C22 3.34315 20.6569 2 19 2V2C17.3431 2 16 3.34315 16 5V5C16 6.65685 17.3431 8 19 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 19H16M5 12L5 16M8 5H12M5 8V8C6.65685 8 8 6.65685 8 5V5C8 3.34315 6.65685 2 5 2V2C3.34315 2 2 3.34315 2 5V5C2 6.65685 3.34315 8 5 8ZM5 22V22C6.65685 22 8 20.6569 8 19V19C8 17.3431 6.65685 16 5 16V16C3.34315 16 2 17.3431 2 19V19C2 20.6569 3.34315 22 5 22ZM19 22V22C20.6569 22 22 20.6569 22 19V19C22 17.3431 20.6569 16 19 16V16C17.3431 16 16 17.3431 16 19V19C16 20.6569 17.3431 22 19 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5Z"
					fill="currentColor"
				/>
				<path
					d="M16 5C16 3.34315 17.3431 2 19 2C20.6569 2 22 3.34315 22 5C22 6.65685 20.6569 8 19 8C17.3431 8 16 6.65685 16 5Z"
					fill="currentColor"
				/>
				<path
					d="M2 19C2 17.3431 3.34315 16 5 16C6.65685 16 8 17.3431 8 19C8 20.6569 6.65685 22 5 22C3.34315 22 2 20.6569 2 19Z"
					fill="currentColor"
				/>
				<path
					d="M16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M8 5H12M5 12V16M19 8V12M12 19H16M19 22V22C20.6569 22 22 20.6569 22 19V19C22 17.3431 20.6569 16 19 16V16C17.3431 16 16 17.3431 16 19V19C16 20.6569 17.3431 22 19 22ZM5 22V22C6.65685 22 8 20.6569 8 19V19C8 17.3431 6.65685 16 5 16V16C3.34315 16 2 17.3431 2 19V19C2 20.6569 3.34315 22 5 22ZM19 8V8C20.6569 8 22 6.65685 22 5V5C22 3.34315 20.6569 2 19 2V2C17.3431 2 16 3.34315 16 5V5C16 6.65685 17.3431 8 19 8ZM5 8V8C6.65685 8 8 6.65685 8 5V5C8 3.34315 6.65685 2 5 2V2C3.34315 2 2 3.34315 2 5V5C2 6.65685 3.34315 8 5 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5 1.25C2.92893 1.25 1.25 2.92893 1.25 5C1.25 7.07107 2.92893 8.75 5 8.75C6.81422 8.75 8.32753 7.46168 8.67499 5.75H12C12.4142 5.75 12.75 5.41421 12.75 5C12.75 4.58579 12.4142 4.25 12 4.25H8.67499C8.32753 2.53832 6.81422 1.25 5 1.25ZM15.25 5C15.25 2.92893 16.9289 1.25 19 1.25C21.0711 1.25 22.75 2.92893 22.75 5C22.75 6.81422 21.4617 8.32753 19.75 8.67499V12C19.75 12.4142 19.4142 12.75 19 12.75C18.5858 12.75 18.25 12.4142 18.25 12V8.67499C16.5383 8.32753 15.25 6.81422 15.25 5ZM5.75 15.325V12C5.75 11.5858 5.41421 11.25 5 11.25C4.58579 11.25 4.25 11.5858 4.25 12L4.25 15.325C2.53832 15.6725 1.25 17.1858 1.25 19C1.25 21.0711 2.92893 22.75 5 22.75C7.07107 22.75 8.75 21.0711 8.75 19C8.75 17.1858 7.46168 15.6725 5.75 15.325ZM15.325 18.25C15.6725 16.5383 17.1858 15.25 19 15.25C21.0711 15.25 22.75 16.9289 22.75 19C22.75 21.0711 21.0711 22.75 19 22.75C17.1858 22.75 15.6725 21.4617 15.325 19.75H12C11.5858 19.75 11.25 19.4142 11.25 19C11.25 18.5858 11.5858 18.25 12 18.25H15.325Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8 5H12M8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5ZM5 12L5 16M5 16C6.65685 16 8 17.3431 8 19C8 20.6569 6.65685 22 5 22C4.64936 22 4.31278 21.9398 4 21.8293M5 16C3.34315 16 2 17.3431 2 19M19 8V12M19 8C17.3431 8 16 6.65685 16 5C16 3.34315 17.3431 2 19 2M19 8C20.6569 8 22 6.65685 22 5C22 4.64936 21.9398 4.31278 21.8293 4M12 19H16M16 19C16 20.6569 17.3431 22 19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16C17.3431 16 16 17.3431 16 19Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M8 5H12M5 12V16M19 8V12M12 19H16M19 22V22C20.6569 22 22 20.6569 22 19V19C22 17.3431 20.6569 16 19 16V16C17.3431 16 16 17.3431 16 19V19C16 20.6569 17.3431 22 19 22ZM5 22V22C6.65685 22 8 20.6569 8 19V19C8 17.3431 6.65685 16 5 16V16C3.34315 16 2 17.3431 2 19V19C2 20.6569 3.34315 22 5 22ZM19 8V8C20.6569 8 22 6.65685 22 5V5C22 3.34315 20.6569 2 19 2V2C17.3431 2 16 3.34315 16 5V5C16 6.65685 17.3431 8 19 8ZM5 8V8C6.65685 8 8 6.65685 8 5V5C8 3.34315 6.65685 2 5 2V2C3.34315 2 2 3.34315 2 5V5C2 6.65685 3.34315 8 5 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.25 5C7.25 4.58579 7.58579 4.25 8 4.25H12C12.4142 4.25 12.75 4.58579 12.75 5C12.75 5.41421 12.4142 5.75 12 5.75H8C7.58579 5.75 7.25 5.41421 7.25 5ZM19 7.25C19.4142 7.25 19.75 7.58579 19.75 8V12C19.75 12.4142 19.4142 12.75 19 12.75C18.5858 12.75 18.25 12.4142 18.25 12V8C18.25 7.58579 18.5858 7.25 19 7.25ZM5 11.25C5.41421 11.25 5.75 11.5858 5.75 12L5.75 16C5.75 16.4142 5.41421 16.75 5 16.75C4.58579 16.75 4.25 16.4142 4.25 16L4.25 12C4.25 11.5858 4.58579 11.25 5 11.25ZM11.25 19C11.25 18.5858 11.5858 18.25 12 18.25H16C16.4142 18.25 16.75 18.5858 16.75 19C16.75 19.4142 16.4142 19.75 16 19.75H12C11.5858 19.75 11.25 19.4142 11.25 19Z"
				fill="currentColor"
			/>
			<path
				d="M1.25 5C1.25 2.92893 2.92893 1.25 5 1.25C7.07107 1.25 8.75 2.92893 8.75 5C8.75 7.07107 7.07107 8.75 5 8.75C2.92893 8.75 1.25 7.07107 1.25 5Z"
				fill="currentColor"
			/>
			<path
				d="M19 1.25C16.9289 1.25 15.25 2.92893 15.25 5C15.25 7.07107 16.9289 8.75 19 8.75C21.0711 8.75 22.75 7.07107 22.75 5C22.75 2.92893 21.0711 1.25 19 1.25Z"
				fill="currentColor"
			/>
			<path
				d="M1.25 19C1.25 16.9289 2.92893 15.25 5 15.25C7.07107 15.25 8.75 16.9289 8.75 19C8.75 21.0711 7.07107 22.75 5 22.75C2.92893 22.75 1.25 21.0711 1.25 19Z"
				fill="currentColor"
			/>
			<path
				d="M19 15.25C16.9289 15.25 15.25 16.9289 15.25 19C15.25 21.0711 16.9289 22.75 19 22.75C21.0711 22.75 22.75 21.0711 22.75 19C22.75 16.9289 21.0711 15.25 19 15.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
